import http from './ajax';

const API_URL = {
  MedicalDecision: '/api/MedicineQuestionnaires/' //醫病清單
};

class MedicalDecisionApi extends http {
  //投稿清單
  MedicalDecisionList = async (params = {}) => {
    try {
      let url = `${API_URL.MedicalDecision}?leaf=${params.leaf}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('MedicalDecisionList', err);
    }
  };

  getMedicalDecisionList = (params = {}) => {
    return this.MedicalDecisionList(params);
  };
}

export default new MedicalDecisionApi();



// WEBPACK FOOTER //
// ./src/service/medical.js